import Phonetic from './Phonetic';

class Pinyin extends Phonetic {
    constructor() {
		super();
		//this.pronunciation = romaji;
		//this.setCharacter();
	}
}

export default Pinyin;